import { useCallback } from "react";
import { useNavigate } from "react-router";
import { RouteFactory } from "@app/routePaths";

/**
 * This hook updates the URL to reflect the active pulse article.
 * It uses the `useNavigate` hook from react-router-dom to change the URL.
 */
export const useHookUpdatePulseUrl = () => {
  const navigate = useNavigate();

  const updatePulseUrl = useCallback(
    (activeId: string) => {
      if (!activeId) return;

      navigate(RouteFactory.pulseSlide(activeId));
    },
    [navigate]
  );

  return { updatePulseUrl };
};
